import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";

export class OrdersListSummary implements Serializable {
    totalOrders: number;
    urgentOrders: number;
    pendingReservationOrders: number;
    promiseRate: number;

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, []);
    }
}
